






























import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheFormStep from "@/common/components/organisms/TheFormStep.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import globals from "@/general/store/modules/globals";
import { Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

// export default {
//   components: {
//     TheHeader,
//     TheSimpleHeader,
//     TheFooter,
//     TheFormStep,
//     CommonHeading,
//     TheBreadcrumb,
//   },
//   props: {
//     step: {
//       type: Number,
//       required: false,
//     },
//     stepOptions: {
//       type: Array,
//       required: false,
//     },
//     isSimpleHeader: {
//       type: Boolean,
//       required: false,
//       default: false,
//     },
//   },
//   methods: {
//     get isSp() {
//       return globals.isLargeBreakpointWidthOfSp;
//     },
//     get addMarginTop() {
//       const style = {
//         marginTop: "105px",
//       };
//       return this.isSp ? style : "";
//     },
//   },
// };
@Component({
  components: {
    TheHeader,
    TheSimpleHeader,
    TheFooter,
    TheFormStep,
    CommonHeading,
    TheBreadcrumb
  }
})
export default class TheTemplateM extends Vue {
  step = false;
  stepOptions = [];
  isSimpleHeader = false;

  $refs!: {
    theHeader: TheHeader;
  };

  headerHeightToStyle = 0;

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  mounted() {
    this.headerHeightToStyle = this.headerHeight;
    window.addEventListener("resize", this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize() {
    this.headerHeightToStyle = this.headerHeight;
  }
}
